package app.vercors.website.blog

class BlogPost(
    val route: String,
    val title: String,
    val date: String,
    val description: String,
)
